// Issue #57's LocationRadiusPicker widget bounds -- pulled out of that
// component (a .tsx that imports tamagui) into its own pure module so
// jest can actually exercise clampRadius: tamagui's native ESM entry
// can't be parsed by jest (same constraint lib/avatar-identity.ts's own
// doc comment documents), so any pure logic a component needs
// unit-tested has to live somewhere that imports nothing from tamagui.
export const MIN_RADIUS_M = 500;
export const MAX_RADIUS_M = 20000;
export const RADIUS_STEP_M = 500;

export function clampRadius(radiusM: number): number {
  return Math.max(MIN_RADIUS_M, Math.min(MAX_RADIUS_M, radiusM));
}
